<template>
  <div class="servicios">
    <v-container fluid class="py-0">
      <v-row class="text-center d-md-none" style="height: 106px;">
        <v-col cols="12" class="azul">
          <div class="texto-centro">
            <router-link to="/">
              <v-img
                src="@/assets/img/logo/logo-blanco.png"
                class="d-block mx-auto"
                width="80px"
              ></v-img>
            </router-link>
          </div>
        </v-col>
      </v-row>
      <v-row class="text-center" style="height: 200px;">
        <v-col cols="12" md="6" class="azul">
          <div class="texto-centro">
            <h1 style="color:white; font-weight: normal;" class="exo texto-mobile-size">Cirugía de Párpados</h1>
          </div>
        </v-col>
        <v-col cols="12" md="6" style="position:relative;" class="before-column pt-0">
          <div class="texto-centro">
            <h3 class="azul_oscuro gotham texto-mobile-2">Mejoramos tu salud visual</h3>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row class="my-8 my-md-12" justify="center">
        <v-col cols="12" offset-md="2" md="8" class="padding-column">
          <v-img
            src="@/assets/img/iconografiaServicios/cirugiadeparpados.svg"
            width="60"
            class="mb-2 d-none d-md-block"
          ></v-img>

          <v-img
            src="@/assets/img/iconografiaServicios/cirugiadeparpados.svg"
            width="137px"
            class="mx-auto d-block d-md-none"
          ></v-img>
          <span
            class="gotham-bold subtitulo-size azul_oscuro d-block text-center text-md-left"
          >¿Qué es?</span>
          <hr style="border: 1px solid #6C8FC9; width: 30%" class="d-block d-md-none mx-auto" />
          <p class="gotham azul_oscuro d-block mt-10 mt-10 px-6 px-md-0 propiedades-parrafos">
            Los párpados en conjunto con los ojos, reflejan nuestras emociones y representan el foco
            de atención en nuestro rostro cuando nos comunicamos. Los cambios relacionados con la
            edad afectan estas áreas pueden ser tratados mediante técnicas avanzadas de Cirugía
            Oculoplástica.
          </p>

          <span
            class="gotham-bold azul_oscuro mt-10 px-6 px-md-0 d-block mt-10"
            style="max-width: 735px; font-size: 20px;"
          >Información útil de la cirugía</span>

          <ul class="gotham azul_oscuro mt-6 px-6 px-md-0">
            <li>Disminuirás la aparición de bolsas en el área de los párpados que producen pliegues</li>
            <li>
              Lucirás una apariencia con menos arrugas que generan la impresión de cansancio y fatiga
              en el rostro
            </li>
            <li>
              Esta cirugía se realiza bajo anestesia local, el procedimiento dura de 2 a 4 horas y el
              paciente regresa a su casa inmediatamente después de concluida la operación
            </li>
            <li>
              Por lo general el paciente no presenta dolor, no es necesario aplicar vendajes o parches
              sobre los ojos y después de la 2ª semana posterior a la cirugía puede integrarse a sus
              actividades diarias.
            </li>
          </ul>
        </v-col>
      </v-row>
      
    </v-container>
  </div>
</template>
<script>


export default {
};
</script>